// extracted by mini-css-extract-plugin
export default {"CardItem":"CardItem_CardItem__dzJXl","CardItem__hover_animation":"CardItem_CardItem__hover_animation__aNkEW","CardItem__flex":"CardItem_CardItem__flex__y0CrO"};